import { DirectionsRenderer, GoogleMap, MarkerF, PolylineF, useLoadScript } from "@react-google-maps/api";
import React, { useEffect, useState } from 'react';

import { Backdrop } from "@mui/material";
import get from "lodash/get";
import DeliveryTruck from "../../assets/img/delivery-truck.png";
import PinStyba from "../../assets/img/pin_styba.png";
import Store from "../../assets/img/store.png";
import StoreSuccess from "../../assets/img/store_success.png";
import CircularProgress from "../form/CircularProgress";
import './styles.css';

const REACT_APP_GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
const defaultLocation = {
    lat: 13.788801745841877,
    lng: -88.92774470563054
}
/**style.css */
const libraries = ["places"];

const MapTrack = ({ locationSuggestions, locationsReal, driverPosition, preserveViewport = false }) => {

    const [truckPosition, setTruckPosition] = useState(null)
    const [tracking, setTracking] = useState([])
    const [routeMain, setRouteMain] = useState({ directions: null, markers: [] })

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: REACT_APP_GOOGLE_MAP_API_KEY,
        libraries
    })


    // route main suggestions
    useEffect(() => {
        if (locationSuggestions.length > 0 && isLoaded) {
            routeSuggestions()
        }
    }, [locationSuggestions])

    const routeSuggestions = async () => {
        let { latitude: originLat, longitude: originLng } = locationSuggestions[0]
        let { latitude: destinationLat, longitude: destinationLng } = locationSuggestions[locationSuggestions.length - 1]
        let _waypoints = locationSuggestions.slice(1, -1)

        let waypoints = _waypoints.length > 0 ? _waypoints.map(({ latitude: lat, longitude: lng }) => ({ location: { lat: parseFloat(lat), lng: parseFloat(lng) }, stopover: true })) : [];

        let markes = locationSuggestions.length > 0 ? locationSuggestions.map(({ latitude: lat, longitude: lng, plantel, statusId }) => ({ lat: parseFloat(lat), lng: parseFloat(lng), plantel, statusId })) : []
        // instaciamos
        const directionService = new window.google.maps.DirectionsService();
        const result = await new Promise((resolve, reject) => {
            directionService.route({
                origin: { lat: parseFloat(originLat), lng: parseFloat(originLng) },
                destination: { lat: parseFloat(destinationLat), lng: parseFloat(destinationLng) },
                travelMode: 'DRIVING',
                waypoints
            }, function (result, status) {
                if (status === window.google.maps.DirectionsStatus.OK) {
                    resolve(result);
                } else {
                    console.log("error: ", status);
                    reject(status)
                }
            })
        });
        setRouteMain({ directions: result, markers: markes })
    }


    // tracking
    useEffect(() => {
        if (locationsReal) {
            let tracks = locationsReal.map(({ latitude: lat, longitude: lng }) => ({ lat: parseFloat(lat), lng: parseFloat(lng) }))
            setTracking(tracks);
        }
    }, [locationsReal])

    // truck position real
    useEffect(() => {
        if (driverPosition) {
            let { latitude, longitude } = driverPosition
            setTruckPosition({ lat: parseFloat(latitude), lng: parseFloat(longitude) });
        }
    }, [driverPosition])

    const renderMap = () => {
        return (<GoogleMap
            center={defaultLocation}
            zoom={9.5}
            mapContainerStyle={{ flex: 1 }}>
            {/* Route main*/}
            {get(routeMain, "directions", null) != null ? <DirectionsRenderer options={{
                directions: get(routeMain, "directions"),
                suppressMarkers: true,
                preserveViewport: preserveViewport
            }} /> : <></>}

            {get(routeMain, "markers", []).length > 0 ? routeMain.markers.map((item, index) => {
                let { lat, lng, plantel, statusId } = item;
                return <MarkerF
                    label={{
                        text: `${index + 1}`,
                        color: "#000000",
                        fontSize: "28px",
                        fontWeight: "bold",
                        className: "custom-marker-label"
                    }}
                    key={index + 1}
                    icon={{
                        url: plantel > 0 ? PinStyba : statusId == 3 ? StoreSuccess : Store,
                        scaledSize: new window.google.maps.Size(70, 70)
                    }} position={{ lat, lng }} />

            }) : <></>}

            {/* truck Position  */}
            {truckPosition != null ?
                <MarkerF
                    key={1}
                    style={{ transition: 'all 0.5s ease' }}
                    icon={{
                        url: DeliveryTruck,
                        scaledSize: new window.google.maps.Size(70, 70)
                    }} position={truckPosition} /> : <></>
            }

            {/* Success Route  */}
            {tracking.length > 0 ?
                <PolylineF
                    path={tracking}
                    options={{
                        strokeColor: "#21F605FF",
                        strokeOpacity: 0.9,
                        strokeWeight: 5,
                        zIndex: 4
                    }}
                    visible
                /> : <></>
            }
        </GoogleMap>)
    }

    if (!isLoaded) return (<div className="h-full w-full relative">
        <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={!isLoaded} >
            <CircularProgress color="inherit" />
        </Backdrop>
    </div>);

    return (
        <div className="h-full w-full relative">
            <div style={{ flexDirection: "column", display: "flex", height: "100%", width: "100%" }}>
                {renderMap()}
            </div>
        </div>
    )
}

export default MapTrack